import React, { useEffect } from "react";
import threedots from "../../resources/images/users.png";
import {
  setShowChat,
  setShowPopUsers,
  setConnection,
} from "../../store/actions";
import { connect } from "react-redux";
import { Tooltip } from "react-tooltip";
import store from "../../store/store";

const MenuButton = (props) => {
  let participantsEnabled = false;
  useEffect(()=>{
    participantsEnabled = localStorage.getItem('participantsEnabled');
  },[])
  const { setShowChatAction, setShowPopUsersAction, showPopUsers } = props;

  const handleMenuButtonPressed = () => {
    setShowChatAction(false);
    setShowPopUsersAction(!showPopUsers);

    const connections = store.getState().connection || [];
    const updatedConnections = connections.map((conn) => ({
      ...conn,
      isExpanded: false,
    }));

    // Dispatch Redux action
    props.setConnection(updatedConnections);
  };
  
  return (
    <div className="video_button_container">
      {participantsEnabled &&
      <div className="icon-container">
        <div className="badge">{store.getState().participants.length}</div>
        <Tooltip id="my-tooltip" />
        <img
          className="video_button_image"
          src={threedots}
          onClick={handleMenuButtonPressed}
          data-tooltip-id="tooltip-participants"
          data-tooltip-content="People"
        />
      </div>
      }
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    setShowPopUsersAction: (showPopUsers) =>
      dispatch(setShowPopUsers(showPopUsers)),
    setShowChatAction: (showChat) => dispatch(setShowChat(showChat)),
    setConnection: (connections) => dispatch(setConnection(connections)),
  };
};

export default connect(mapStoreStateToProps, mapActionsToProps)(MenuButton);